import { CountryFlag } from "components/UI/CountryFlag/CountryFlag.tsx";
import { EmptyCell } from "components/UI/Table/UI/EmptyCell/EmptyCell.tsx";

import CountryData = App.Data.CountryData;

interface CountryCellProps {
    country?: CountryData | null;
}

export const CountryCell = ({ country }: CountryCellProps) => {
    if (!country) {
        return <EmptyCell />;
    }
    return <CountryFlag country={country} />;
};
